import PluginOutlet from "discourse/components/plugin-outlet";
import lazyHash from "discourse/helpers/lazy-hash";
import { i18n } from "discourse-i18n";

export default <template>
  <PluginOutlet
    @name="community-navigation-media-gallery-page"
    @outletArgs={{lazyHash
      game=@model.game
      type=@model.type
      sort=@model.sort
      page=@model.page
    }}
  >
    <section class="community-placeholder-page">
      <h1 class="community-placeholder-page__title">{{i18n "community_navigation.media_gallery"}}</h1>
      <p class="community-placeholder-page__description">{{i18n
          "community_navigation.placeholders.media_gallery"
        }}</p>
    </section>
  </PluginOutlet>
</template>;
